import {
    FILTER_CANDIDATE_REQUEST,
    FILTER_CANDIDATE_SUCCESS,
    FILTER_CANDIDATE_FAILURE,
  } from './actions';
  
  const initialState = {
    candidates: [],
    loading: false,
    error: null,
  };
  
  const filterReducer = (state = initialState, action) => {
    switch (action.type) {
      case FILTER_CANDIDATE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FILTER_CANDIDATE_SUCCESS:
        return {
          ...state,
          candidates: action.payload,
          loading: false,
          error: null,
        };
      case FILTER_CANDIDATE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default filterReducer;
  